import { BoxIcon } from 'lucide-react'
import { GroupButtons } from '@/components/ui/GroupButtons'

export default function ButtonGroupPlayground() {
  return (
    <>
      <h2>Button Group</h2>
      <div className="h- flex  flex-wrap gap-3 ">
        <GroupButtons
          variant="default"
          buttons={[
            { icon: <BoxIcon />, label: 'Button 1' },
            { label: 'Button 2' },
            { label: 'Button 3' },
            { label: 'Button 4' },
          ]}
        />
        <GroupButtons
          variant="outline"
          buttons={[
            { icon: <BoxIcon />, label: 'Button 1' },
            { label: 'Button 2' },
            { label: 'Button 3' },
            { icon: <BoxIcon /> },
          ]}
        />
      </div>
    </>
  )
}
